import { Dialog } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { useDownloadLink } from '../../queries/use-download-link';
import { FileRecordNew } from '../../types/file-record';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';
import { useUserContext } from '../../providers/UserProvider';
import { hasWriteAccess } from './file-utils';

type ViewErrorDialogProps = {
    record: FileRecordNew;
    onClose: () => void;
};

function ViewErrorDialog({ record, onClose }: ViewErrorDialogProps): JSX.Element {
    const [enabled, setEnabled] = useState(false);

    const { isExternalUser } = useIsFirmRole();
    const { assignedWorkpapers } = useUserContext();

    const canCheckOut = hasWriteAccess(isExternalUser, assignedWorkpapers, [record.path]);
    const downloadLinkQuery = useDownloadLink([record.source?.id ? record.source?.id : record.id], enabled);

    useEffect(() => {
        if (downloadLinkQuery.data?.urls) {
            for (const { url } of downloadLinkQuery.data?.urls) {
                // Start the download
                const element = document.createElement('a');
                element.setAttribute('href', url);
                element.setAttribute('download', record.name || 'filename.txt');
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                onClose();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [downloadLinkQuery.data?.urls]);

    return (
        <Dialog
            title="Unable to View Document"
            description={`${record.name} cannot be viewed in the browser. You will have to download this document to view it. ${
                canCheckOut ? 'Downloading this document will check it out.' : ''
            }`}
            type="error"
            primaryAction="Download"
            secondaryAction="Cancel"
            isOpen
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={(): void => {
                setEnabled(true);
            }}
            isLoading={downloadLinkQuery.isLoading}
        />
    );
}
export default ViewErrorDialog;
